// extracted by mini-css-extract-plugin
export default {"mediaWrapper":"PhotoGrid_mediaWrapper__STsvV","blurredBackground":"PhotoGrid_blurredBackground__KqBW6","mediaContent":"PhotoGrid_mediaContent__zovUN"};